module.exports = __webpack_public_path__ + "diamo-clanek.jpg?48988ac00a58eba4f630ebd654eef034";


//////////////////
// WEBPACK FOOTER
// ./dist/diamo-clanek.jpg
// module id = 286
// module chunks = 0